import * as React from "react";
const SvgElectricalServicesOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zM20 17h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zM12 14h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z" />
    <path d="M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z" />
  </svg>
);
export default SvgElectricalServicesOutlined;
